
import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { CompetitionMatchForm } from '../../competition/CompetitionMatchForm';
import { TrainingFormValues } from '../../../types';
import { CompetitionMatch } from '../../../types/competition';

interface CompetitionSectionProps {
  form: UseFormReturn<TrainingFormValues>;
}

export function CompetitionSection({ form }: CompetitionSectionProps) {
  const matches = form.watch('competition_matches') || [];

  const addMatch = () => {
    const currentMatches = form.getValues('competition_matches') || [];
    form.setValue('competition_matches', [
      ...currentMatches,
      {
        gi_nogi: 'gi',
        weight_class: '',
        result: 'win',
        method: 'points',
        division: 'Adult'
      } as CompetitionMatch
    ]);
  };

  const removeMatch = (index: number) => {
    const currentMatches = form.getValues('competition_matches') || [];
    form.setValue(
      'competition_matches',
      currentMatches.filter((_, i) => i !== index)
    );
  };

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <FormField
          control={form.control}
          name="competition_finish"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Competition Result</FormLabel>
              <FormControl>
                <Input {...field} placeholder="e.g. Gold, Silver, Bronze" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-medium">Matches</h3>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={addMatch}
          >
            <Plus className="h-4 w-4 mr-2" />
            Add Match
          </Button>
        </div>

        <div className="space-y-4">
          {matches && matches.map((_, index) => (
            <CompetitionMatchForm
              key={index}
              form={form}
              index={index}
              onRemove={() => removeMatch(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
